import gql from 'graphql-tag';

const QUERY_CHANGE_PASSWORD = gql`
  mutation changePassword($input: ChangePasswordInput!) {
    changePassword(input: $input) {
      isSuccess
      message
    }
  }
`;

export default QUERY_CHANGE_PASSWORD;
